export default __webpack_public_path__ + "static/media/3-6-1.fdb55063.jpg";